import { cssUtil } from "../utils/cssUtil";
import { getBaseStyles } from "./commonStyles";

export async function renderGroupWidget(context, widget, parent, override = null) {

    // Create wrapper
    const element = context.document.createElement("div");
    element.classList.add("widget", "group_widget");
    const breakpoint = context.currentBreakpoint;
    

    const styles = getBaseStyles(widget, breakpoint);
    element.setAttribute("style", cssUtil.toStyleString(styles));
    element.setAttribute("data-widgetId", widget.uid);
    element.setAttribute("data-widgetType", widget.type);
    element.setAttribute("data-widgetParent", widget.parent);

    parent.appendChild(element);

    // Render children
    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || children.length === 0) {
        return;
    }

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, element);
    }

    return element;
}
